import { Injectable } from '@angular/core'
import { Resolve } from '@angular/router'

import { OperadoraDeMaquina } from '../../pkw-data/collect/operadora-de-maquina.model'
import { OperadoraDeMaquinaService } from '../services/operadora-de-maquina.service'

@Injectable()
export class OperadorasComEstabelecimentoResolver
    implements Resolve<OperadoraDeMaquina[]> {
    constructor(private operadoraService: OperadoraDeMaquinaService) {}

    resolve() {
        return this.operadoraService.obterPossuemEstabelecimentos()
    }
}



// WEBPACK FOOTER //
// ./src/app/core/resolvers/operadoras-com-estabelecimento.resolver.ts